import api from '../services/api';

export async function getSites(params = null) {
  try {
    // Use the sites endpoint defined in ApiRouter
    const response = await api.get('/api/sites', { params });
    
    // Transform the API response to the expected format
    if (response.data && response.data.status === 1) {
      // API returns { status: 1, message: "Success", data: { rows: [...sites] } }
      // Components expect { status: 1, rows: [...sites], message: "Success" }
      const sites = response.data.data?.rows || [];
      
      return {
        status: 1,
        rows: sites,
        data: {
          rows: sites,
          meta: {
            totalItems: sites.length
          }
        },
        message: response.data.message
      };
    }
    
    return response.data;
  } catch (error) {
    console.error('Error fetching sites:', error);
    throw error;
  }
}

export async function getSite(id) {
  try {
    // Use the /:id endpoint defined in ApiRouter
    const response = await api.get(`/api/sites/${id}`);
    
    // API returns { status: 1, message: "Success", data: { row: {...site data...}, config: {...} } }
    // Component expects { status: 1, row: {...site data...}, message: "Success" }
    if (response.data && response.data.status === 1 && response.data.data) {
      return {
        status: response.data.status,
        row: response.data.data.row,
        config: response.data.data.config,
        message: response.data.message
      };
    }
    
    return response.data;
  } catch (error) {
    console.error(`Error fetching site ${id}:`, error);
    throw error;
  }
}

// Alias for backward compatibility
export async function getSiteById(id) {
  return getSite(id);
}

export async function createSite(siteData) {
  try {
    // Use the POST endpoint defined in ApiRouter
    const response = await api.post('/api/sites', siteData);
    return response.data;
  } catch (error) {
    console.error('Error creating site:', error);
    throw error;
  }
}

export async function updateSite(id, siteData) {
  try {
    // Add site_id to the data and use the update endpoint defined in ApiRouter
    siteData.site_id = id;
    const response = await api.post('/api/sites/update', siteData);
    return response.data;
  } catch (error) {
    console.error(`Error updating site ${id}:`, error);
    throw error;
  }
}

export async function deleteSite(id) {
  try {
    // Use the delete endpoint defined in ApiRouter
    const response = await api.delete(`/api/sites/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting site ${id}:`, error);
    throw error;
  }
}

export async function getSiteTypes() {
  try {
    // Use the create endpoint which should return site types in the config
    const response = await api.get('/api/sites/create');
    // Return the types from the config or an empty array
    return {
      status: 1,
      types: response.data?.config?.site_types || []
    };
  } catch (error) {
    console.error('Error fetching site types:', error);
    throw error;
  }
}
